// eslint-disable-next-line import/prefer-default-export
export const rolesLabels = {
  'initiative-admin': 'Initiative Admin',
  'initiative-manager': 'Initiative Manager',
  'initiative-organizer': 'Initiative Organizer',
  'initiative-assignee': 'Initiative Assignee',
  'organization-admin': 'Organization Admin',
  'organization-user': 'Organization User',
  'data-assignee': 'Data Assignee',
  'petition-image-viewer': 'Petition Image Viewer',
  'petition-uploader': 'Petition Uploader',
  'auxiliary-task-specialist': 'Auxiliary Task Specialist',
  'report-viewer': 'Report Viewer',
  'canvassing-organization-user': 'Canvassing Organization User',
  'election-official-admin': 'Election Official Admin',
  'election-official-assignee': 'Election Official Assignee',
};

export const circulatorRoles = [
  'initiative-admin',
  'initiative-manager',
  'initiative-organizer',
  'initiative-assignee',
];

export const unauthenticatableRoles = ['initiative-assignee'];
